import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import Button from 'helpers/Button';
import SectionWrapper from 'ferries/Home/components/SectionWrapper';
import TestimonialItem from 'ferries/Home/components/Testimonials/TestimonialItem';
import TestimonialLogo from 'ferries/Home/components/Testimonials/TestimonialLogo';
import TestimonialStars from 'ferries/Home/components/Testimonials/TestimonialStars';
import {sourceName} from 'ferries/Home/components/Testimonials/helper';
import {capitalize} from 'ferries/helpers/common';
import {DESKTOP_WIDTH} from 'helpers/stableValues';

const sliderSettings = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 2,
  slidesToScroll: 2,
  arrows: true,
  style: {zIndex: 3},
  responsive: [{
    breakpoint: DESKTOP_WIDTH,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1
    }
  }]
};


const Testimonials = ({testimonials}) => {
  const {title, subtitle, description, items, url, trs} = testimonials;

  return (
    <SectionWrapper title={title} subtitle={subtitle} description={description}>
      <div className="w-md-7-10 mx-auto position-relative">
        <Slider {...sliderSettings}>
          {
            items.map(({title, text, name, date, stars, source}, index) => {
              return (
                <div key={index} className="px-3">
                  <div className="py-5">
                    <TestimonialLogo source={source} />
                    <TestimonialItem
                      title={title}
                      text={text}
                      translations={trs}
                    />
                    <div className="d-md-flex justify-content-between">
                      <div className="d-flex align-items-center">
                        <div className="text-truncate">
                          <h3 className="text-danger m-0">{name}</h3>
                          <div className="text-muted text-small">{date}</div>
                        </div>
                      </div>
                      <TestimonialStars
                        source={source}
                        stars={stars}
                      />
                    </div>
                  </div>
                </div>
              );
            })
          }
        </Slider>
        <div className="grid align-items-center justify-content-center">
          {
            Object.keys(url).map((source, index) => (
              <div key={index} className='text-center mt-3 grid-item-lg grid-item-8-10'>
                <Button
                  outline
                  className="w-9-10"
                  status="primary"
                  target="_blank"
                  rel="noreferrer"
                  href={url[source]}
                >
                  {trs.viewAllReviewsOn
                    .replace('{source}', capitalize(sourceName[source]))}
                </Button>
              </div>
            ))
          }
        </div>
      </div>
    </SectionWrapper>
  );
};

Testimonials.propTypes = {
  testimonials: PropTypes.shape({
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    url: PropTypes.PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object
    ]).isRequired,
    items: PropTypes.array.isRequired,
    trs: PropTypes.shape({
      viewAllReviewsOn: PropTypes.string.isRequired
    })
  })
};

export default Testimonials;
